import { lazy } from 'react'
import * as Icons from 'react-feather'
import ChunkLoader from "router/ChunkLoader"

const routes = [
  {
    id: 'home',
    navLink: '/app/home',
    component: lazy(() => ChunkLoader(() => import('views/@enterprise/app/Listing'))),
    pagePermissions: ["user"],
    title: 'Job List',
    icon: <Icons.Briefcase size={20} />
  },
  {
    id: 'dashboard',
    navLink: '/app/dashboard',
    component: lazy(() => ChunkLoader(() => import('views/@enterprise/app/Dashboard'))),
    pagePermissions: ["user"],
    title: 'Job Dashboard',
    icon: <Icons.Airplay size={20} />,
    query: ["jobId"],
  },
  {
    id: 'applicants',
    navLink: '/app/applicants',
    component: lazy(() => ChunkLoader(() => import('views/@enterprise/app/Applicants'))),
    pagePermissions: ["user"],
    title: 'Job Applicants',
    icon: <Icons.Users size={20} />,
    query: ["jobId"]
  },
  // {
  //   id: 'scorechanger',
  //   navLink: '/app/scorechanger',
  //   component: lazy(() => ChunkLoader(() => import('views/@enterprise/app/ScoreChanger'))),
  //   pagePermissions: ["user"],
  //   title: 'Score Changer',
  //   icon: <Icons.Sliders size={20} />,
  //   query: ["jobId"]
  // },
  {
    id: "resume",
    navLink: "/app/resume",
    component: lazy(() => ChunkLoader(() => import('views/@enterprise/app/Resume'))),
    pagePermissions: ["user"],
    title: 'Candidate\'s Resume',
    icon: <Icons.Clipboard size={20} />,
    query: ["jobId", "applicantId"]
  },
  {
    id: "resumeprint",
    navLink: "/app/resumeprint",
    component: lazy(() => ChunkLoader(() => import('views/@enterprise/app/ResumePrint'))),
    pagePermissions: ["user"],
    query: ["jobId", "applicantId"],
    layout: 'BlankLayout'
  },
  {
    id: "assessment",
    navLink: "/app/assessment",
    component: lazy(() => ChunkLoader(() => import('views/@enterprise/app/Assessment'))),
    pagePermissions: ["user"],
    title: 'Candidate\'s Assessment',
    icon: <Icons.FileText size={20} />,
    query: ["jobId", "applicantId", "referenceId"]
  },
  {
    id: "assessmentprint",
    navLink: "/app/assessmentprint",
    component: lazy(() => ChunkLoader(() => import('views/@enterprise/app/AssessmentPrint'))),
    pagePermissions: ["user"],
    query: ["jobId", "applicantId", "referenceId"],
    layout: 'BlankLayout'
  },
  {
    id: 'settings',
    navLink: '/app/settings',
    component: lazy(() => ChunkLoader(() => import('views/@enterprise/app/Settings'))),
    pagePermissions: ["user"],
    title: 'Job Preferences',
    icon: <Icons.Settings size={20} />,
    query: ["jobId"]
  },
  {
    id: 'productguide',
    navLink: '/app/productguide',
    component: lazy(() => ChunkLoader(() => import('views/@enterprise/app/ProductGuide'))),
    pagePermissions: ["user"],
    title: 'Product Guide',
    icon: <Icons.Info size={20} />,
    query: ["jobId"]
  },
]

export default routes;
